module.exports = __webpack_public_path__ + "static/img/equipment3new.0735cd36.png";